export const GetFundColor = (type: string) => {
  if (type === "Rentefond") return "#7CB5EC";
  else if (type === "Aksjefond") return "#90ED7D";
  return "var(--color-white)";
};
